import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "text-left" }

import { Checkbox, Icon } from "@toruslabs/vue-components";
import { computed } from "vue";

export type ListItemClassesKey = "name" | "description";

export type LIST_ITEM = {
  id?: number;
  name: string;
  description?: string;
  icon?: string;
  value?: string;
  href?: string;
};

type Props = {
  item: LIST_ITEM;
  link?: boolean;
  active?: boolean;
  showCheckbox?: boolean;
  classes?: Partial<Record<ListItemClassesKey, string>>;
  readonly?: boolean;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'ListItem',
  props: {
    item: {},
    link: { type: Boolean },
    active: { type: Boolean, default: false },
    showCheckbox: { type: Boolean, default: false },
    classes: { default: () => ({}) },
    readonly: { type: Boolean, default: false }
  },
  emits: ["onClick"],
  setup(__props: any, { emit: emits }) {

const props = __props;





const tag = computed(() => {
  if (props.item.href) return "a";
  return props.link && !props.readonly ? "button" : "div";
});

const selectItem = () => {
  if (props.readonly) return;
  emits("onClick", props.item);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(tag.value), {
    class: _normalizeClass(["w-full flex items-center px-5 py-4", _ctx.active ? 'bg-app-gray-50 dark:bg-app-gray-800' : '']),
    href: _ctx.item.href || undefined,
    target: _ctx.item.href ? '_blank' : undefined,
    rel: _ctx.item.href ? 'noreferrer noopener' : undefined,
    onClick: _withModifiers(selectItem, ["stop","exact"])
  }, {
    default: _withCtx(() => [
      (_ctx.showCheckbox)
        ? (_openBlock(), _createBlock(_unref(Checkbox), {
            key: 0,
            checked: _ctx.active,
            class: "mr-3"
          }, null, 8, ["checked"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "icon", {}, () => [
        (_ctx.item.icon)
          ? (_openBlock(), _createBlock(_unref(Icon), {
              key: 0,
              class: "mr-2 text-app-gray-500",
              name: _ctx.item.icon,
              size: "32"
            }, null, 8, ["name"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "name", {}, () => [
          _createElementVNode("div", {
            class: _normalizeClass(["text-sm text-app-gray-900 dark:text-white font-semibold", [_ctx.classes?.name]])
          }, _toDisplayString(_ctx.item.name), 3)
        ]),
        _renderSlot(_ctx.$slots, "description", {}, () => [
          _createElementVNode("div", {
            class: _normalizeClass(["text-xs text-app-gray-500 dark:text-app-gray-400", [_ctx.classes?.description]])
          }, _toDisplayString(_ctx.item.description), 3)
        ])
      ]),
      _renderSlot(_ctx.$slots, "rightPanel", {}, () => [
        (_ctx.link && !_ctx.readonly)
          ? (_openBlock(), _createBlock(_unref(Icon), {
              key: 0,
              class: "ml-auto dark:text-app-gray-400",
              name: "chevron-right-icon",
              size: "16"
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 3
  }, 8, ["class", "href", "target", "rel", "onClick"]))
}
}

})